import { render } from "./SimpleNotesTable.vue?vue&type=template&id=8b6f2f88&scoped=true"
import script from "./SimpleNotesTable.vue?vue&type=script&lang=js"
export * from "./SimpleNotesTable.vue?vue&type=script&lang=js"

import "./SimpleNotesTable.vue?vue&type=style&index=0&id=8b6f2f88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6f2f88"]])

export default __exports__